import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";

function App() {
  const [auth, setAuth] = useState({
    isLoading: true,
    isAuthenticated: false,
    user: null,    
    roles: []     
  });

  // Vérification au chargement
  useEffect(() => {
    async function checkAuth() {
      try {
        const response = await fetch('/api/check-auth');
        
        if (response.status === 200) {
          const data = await response.json();
          // API 
          setAuth({
            isLoading: false,
            isAuthenticated: true,
            user: data.email,   
            roles: data.roles || [] 
          });
        } else {
          setAuth({ isLoading: false, isAuthenticated: false, user: null, roles: [] });
        }
      } catch (error) {
        console.error("Erreur API", error);
        setAuth({ isLoading: false, isAuthenticated: false, user: null, roles: [] });
      }
    }
    checkAuth();
  }, []);


  function RequireAuth({ children }) {
    if (auth.isLoading) {
    
      return <div className="flex justify-center items-center h-screen">Chargement...</div>; 
    }

    if (!auth.isAuthenticated) {
      return <Navigate to="/login" replace />;
    }

    return children;
  }

  // Routes
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route 
        path="/dashboard/*"
        element={
          <RequireAuth>
            {/* rôles au Dashboard */}
            <Dashboard 
                userRoles={auth.roles} 
                userName={auth.user} 
            />
          </RequireAuth>
        } 
      />

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default App;
